import { Package } from '../models/package';
import { DimensionUnitEnum } from '../enum/dimension-unit.enum';
import { WeightUnitEnum } from '../enum/weight-unit.enum';

export function freightClass(pkg: Package, weightUnit: WeightUnitEnum, dimensionUnit: DimensionUnitEnum): string
{
    const weightLbs = pkg.weight * (weightUnit === WeightUnitEnum.KG ? 2.20462 : 1);
    const widthInches = pkg.width * (dimensionUnit === DimensionUnitEnum.CM ? 0.393701 : 1);
    const lengthInches = pkg.length * (dimensionUnit === DimensionUnitEnum.CM ? 0.393701 : 1);
    const heightInches = pkg.height * (dimensionUnit === DimensionUnitEnum.CM ? 0.393701 : 1);
    const volumeCubicFeet = (widthInches * lengthInches * heightInches) / 1728;
    const density = weightLbs / volumeCubicFeet;
    if (density >= 50.0) {
        return '50';
    }
    if (density >= 35.0) {
        return '55';
    }
    if (density >= 30.0) {
        return '60';
    }
    if (density >= 22.5) {
        return '65';
    }
    if (density >= 15.0) {
        return '70';
    }
    if (density >= 12.0) {
        return '85';
    }
    if (density >= 10.0) {
        return '92.5';
    }
    if (density >= 8.0) {
        return '100';
    }
    if (density >= 6.0) {
        return '125';
    }
    if (density >= 4.0) {
        return '175';
    }
    if (density >= 2.0) {
        return '250';
    }
    if (density >= 1.0) {
        return '300';
    }
    return '400';
}
